
export const checkPermissionUser = (array, permission) => {
    try {
        const result = array.filter(data => {
            if (data.permission === permission && data.state )
                return true
            else 
                return false
        })
        if (result.length > 0) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}